import { render, staticRenderFns } from "./StatisticsByCar.vue?vue&type=template&id=3d95c4e4&scoped=true&"
import script from "./StatisticsByCar.vue?vue&type=script&lang=js&"
export * from "./StatisticsByCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95c4e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
